// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General */
* {
  box-sizing: border-box;
}

html {
  height: 100%;
}

body {
  font-family: var(--font-family);
  color: var(--text-color);
  background-color: var(--surface-ground);
  margin: 0;
  padding: 0;
  min-height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  text-decoration: none;
  color: var(--primary-color);
}

.layout-wrapper {
  min-height: 100vh;
}

.layout-topbar {
  position: fixed;
  height: 5rem;
  z-index: 997;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0 2rem;
  background-color: var(--surface-card);
  transition: left 0.2s;
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
}
.layout-topbar .layout-topbar-logo {
  display: flex;
  align-items: center;
  color: var(--surface-900);
  font-size: 1.5rem;
  font-weight: 500;
  width: 300px;
  border-radius: 12px;
}
.layout-topbar .layout-topbar-logo img {
  height: 2.5rem;
  margin-right: 0.5rem;
}
.layout-topbar .layout-topbar-logo:focus {
  outline: 0 none;
  outline-offset: 0;
  transition: box-shadow 0.2s;
  box-shadow: var(--focus-ring);
}
.layout-topbar .layout-topbar-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: var(--text-color-secondary);
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.layout-topbar .layout-topbar-button:hover {
  color: var(--text-color);
  background-color: var(--surface-hover);
}
.layout-topbar .layout-topbar-button:focus {
  outline: 0 none;
  outline-offset: 0;
  transition: box-shadow 0.2s;
  box-shadow: var(--focus-ring);
}
.layout-topbar .layout-topbar-button i {
  font-size: 1.5rem;
}
.layout-topbar .layout-topbar-button span {
  font-size: 1rem;
  display: none;
}
.layout-topbar .layout-menu-button {
  margin-left: 2rem;
}
.layout-topbar .layout-topbar-menu-button {
  display: none;
}
.layout-topbar .layout-topbar-menu-button i {
  font-size: 1.25rem;
}
.layout-topbar .layout-topbar-menu {
  margin: 0 0 0 auto;
  padding: 0;
  list-style: none;
  display: flex;
}
.layout-topbar .layout-topbar-menu .layout-topbar-button {
  margin-left: 1rem;
}

@media (max-width: 991px) {
  .layout-topbar {
    justify-content: space-between;
  }
  .layout-topbar .layout-topbar-logo {
    width: auto;
    order: 2;
  }
  .layout-topbar .layout-menu-button {
    margin-left: 0;
    order: 1;
  }
  .layout-topbar .layout-topbar-menu-button {
    display: inline-flex;
    margin-left: 0;
    order: 3;
  }
  .layout-topbar .layout-topbar-menu {
    margin-left: 0;
    position: absolute;
    flex-direction: column;
    background-color: var(--surface-overlay);
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 1rem;
    right: 2rem;
    top: 5rem;
    min-width: 15rem;
    display: none;
    animation: scalein 0.15s linear;
  }
  .layout-topbar .layout-topbar-menu.layout-topbar-menu-mobile-active {
    display: block;
  }
  .layout-topbar .layout-topbar-menu .layout-topbar-button {
    margin-left: 0;
    display: flex;
    width: 100%;
    height: auto;
    justify-content: flex-start;
    border-radius: 12px;
    padding: 1rem;
  }
  .layout-topbar .layout-topbar-menu .layout-topbar-button i {
    font-size: 1rem;
    margin-right: 0.5rem;
  }
  .layout-topbar .layout-topbar-menu .layout-topbar-button span {
    font-weight: medium;
    display: block;
  }
}
.layout-sidebar {
  position: fixed;
  width: 300px;
  height: calc(100vh - 9rem);
  z-index: 999;
  overflow-y: auto;
  -webkit-user-select: none;
          user-select: none;
  top: 7rem;
  left: 2rem;
  transition: transform 0.2s, left 0.2s;
  background-color: var(--surface-overlay);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
}

.layout-menu {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.layout-menu li.layout-menuitem-category {
  margin-top: 0.75rem;
}
.layout-menu li.layout-menuitem-category:first-child {
  margin-top: 0;
}
.layout-menu li .layout-menuitem-root-text {
  text-transform: uppercase;
  color: var(--surface-900);
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}
.layout-menu li a {
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  color: var(--text-color);
  transition: color 0.2s;
  border-radius: 12px;
  padding: 0.75rem 1rem;
  transition: background-color 0.15s;
}
.layout-menu li a span {
  margin-left: 0.5rem;
}
.layout-menu li a .menuitem-toggle-icon {
  margin-left: auto;
}
.layout-menu li a:focus {
  outline: 0 none;
  outline-offset: 0;
  transition: box-shadow 0.2s;
  box-shadow: inset var(--focus-ring);
}
.layout-menu li a:hover {
  background-color: var(--surface-hover);
}
.layout-menu li a.router-link-exact-active {
  font-weight: 700;
  color: var(--primary-color);
}
.layout-menu li a .p-badge {
  margin-left: auto;
}
.layout-menu li.active-menuitem > a .menuitem-toggle-icon:before {
  content: "\\e933";
}
.layout-menu li ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.layout-menu li ul.layout-submenu-wrapper-enter {
  max-height: 0;
}
.layout-menu li ul.layout-submenu-wrapper-enter-active {
  overflow: hidden;
  max-height: 1000px;
  transition: max-height 1s ease-in-out;
}
.layout-menu li ul.layout-submenu-wrapper-enter-done {
  transform: none;
}
.layout-menu li ul.layout-submenu-wrapper-exit {
  max-height: 1000px;
}
.layout-menu li ul.layout-submenu-wrapper-exit-active {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.45s cubic-bezier(0.86, 0, 0.07, 1);
}
.layout-menu li ul ul {
  padding-left: 1rem;
}

.layout-config-button {
  display: block;
  position: fixed;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  background: var(--primary-color);
  color: var(--primary-color-text);
  text-align: center;
  top: 50%;
  right: 0;
  margin-top: -1.5rem;
  border-top-left-radius: var(--border-radius);
  border-bottom-left-radius: var(--border-radius);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition: background-color var(--transition-duration);
  overflow: hidden;
  cursor: pointer;
  z-index: 999;
  box-shadow: -0.25rem 0 1rem rgba(0, 0, 0, 0.15);
}
.layout-config-button.config-link {
  font-size: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  border: none;
}
.layout-config-button .config-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 1px var(--focus-ring);
}
.layout-config-button i {
  font-size: 2rem;
  line-height: inherit;
  transform: rotate(0deg);
  transition: transform 1s;
}
.layout-config-button:hover {
  background: var(--primary-400);
}

.layout-config-sidebar.p-sidebar .p-sidebar-content {
  padding-left: 2rem;
  padding-right: 2rem;
}

.layout-main-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  padding: 7rem 2rem 2rem 4rem;
  transition: margin-left 0.2s;
}

.layout-main {
  flex: 1 1 auto;
}

.layout-footer {
  transition: margin-left 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  border-top: 1px solid var(--surface-border);
}

@media (min-width: 992px) {
  .layout-wrapper.layout-overlay .layout-main-container {
    margin-left: 0;
    padding-left: 2rem;
  }
  .layout-wrapper.layout-overlay .layout-sidebar {
    transform: translateX(-100%);
    left: 0;
    top: 0;
    height: 100vh;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .layout-wrapper.layout-overlay.layout-overlay-sidebar-active .layout-sidebar {
    transform: translateX(0);
  }
  .layout-wrapper.layout-static .layout-main-container {
    margin-left: 300px;
  }
  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-sidebar {
    transform: translateX(-100%);
    left: 0;
  }
  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-main-container {
    margin-left: 0;
    padding-left: 2rem;
  }
  .layout-wrapper .layout-mask {
    display: none;
  }
}
@media (max-width: 991px) {
  .layout-wrapper .layout-main-container {
    margin-left: 0;
    padding-left: 2rem;
  }
  .layout-wrapper .layout-sidebar {
    transform: translateX(-100%);
    left: 0;
    top: 0;
    height: 100vh;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .layout-wrapper .layout-mask {
    z-index: 998;
    background-color: var(--mask-bg);
  }
  .layout-wrapper .layout-mask.layout-mask-enter-from, .layout-wrapper .layout-mask.layout-mask-leave-to {
    background-color: transparent;
  }
  .layout-wrapper.layout-mobile-sidebar-active .layout-sidebar {
    transform: translateX(0);
  }
  .layout-wrapper.layout-mobile-sidebar-active .layout-mask {
    display: block;
  }
  .body-overflow-hidden {
    overflow: hidden;
  }
}
/* Utils */
.clearfix:after {
  content: " ";
  display: block;
  clear: both;
}

.card {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: var(--card-shadow);
  border-radius: 12px;
}
.card:last-child {
  margin-bottom: 0;
}

.p-toast.p-toast-top-right, .p-toast.p-toast-top-left, .p-toast.p-toast-top-center {
  top: 100px;
}

h1, h2, h3, h4, h5, h6 {
  margin: 1.5rem 0 1rem 0;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: var(--surface-900);
}
h1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child {
  margin-top: 0;
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.75rem;
}

h4 {
  font-size: 1.5rem;
}

h5 {
  font-size: 1.25rem;
}

h6 {
  font-size: 1rem;
}

mark {
  background: #FFF8E1;
  padding: 0.25rem 0.4rem;
  border-radius: 12px;
  font-family: monospace;
}

blockquote {
  margin: 1rem 0;
  padding: 0 2rem;
  border-left: 4px solid #90A4AE;
}

hr {
  border-top: solid var(--surface-border);
  border-width: 1px 0 0 0;
  margin: 1rem 0;
}

p {
  margin: 0 0 1rem 0;
  line-height: 1.5;
}
p:last-child {
  margin-bottom: 0;
}

.border-left-10 {
  border-left-width: 10px !important;
  border-left-style: solid;
}

@media (min-width: 992px) {
  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-main-container {
    margin-left: 0;
    padding-left: 0rem;
  }
}
.layout-sidebar {
  position: fixed;
  width: 300px;
  height: calc(100vh - 5rem);
  z-index: 999;
  overflow-y: auto;
  -webkit-user-select: none;
          user-select: none;
  top: 5rem;
  left: 0rem;
  transition: transform 0.2s, left 0.2s;
  background-color: var(--surface-overlay);
  border-radius: 0px;
  padding: 1.5rem 0rem 0rem 1.5rem;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
}

.layout-main-container {
  padding: 5rem 0rem 0rem 0rem;
}

.layout-main-card .p-card-body {
  padding: 0.75rem;
}
.layout-main-card .p-card-body .p-card-content {
  padding: 0rem;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
}

.p-tabview .p-tabview-panels {
  padding: 0.5rem 0rem 0.5rem 0.5rem;
}

.addPanel .p-panel-header {
  padding: 0.75rem 1.25rem 0.75rem 1.25rem;
}
.addPanel .p-panel-content {
  padding: 0.5rem 0.5rem 0rem 0.5rem;
}
.addPanel .p-panel-content .p-inputtext-sm {
  height: 40px;
}

.editMode .p-panel-header {
  padding: 0.75rem 1.25rem 0.75rem 1.25rem;
  color: #EF4444;
}

.rotate-45 {
  transform: rotate(45deg);
}

.rowDelete {
  opacity: 0;
}

.p-datatable-tbody > tr:not(.p-datatable-emptymessage):hover .rowDelete {
  color: #EF4444;
  opacity: 1;
}

.rowEdit {
  opacity: 0;
}

.p-datatable-tbody > tr:not(.p-datatable-emptymessage):hover .rowEdit {
  color: #3B82F6;
  opacity: 1;
}

.isCheckbox .p-checkbox-box {
  margin-top: 0.75rem;
}

.trashIcon {
  color: #EF4444;
}

.p-column-filter-menu {
  display: inline-flex;
  margin-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/layout/_variables.scss","webpack://./src/assets/layout/sass/_main.scss","webpack://./src/assets/layout/layout.scss","webpack://./src/assets/layout/sass/_topbar.scss","webpack://./src/assets/layout/sass/_mixins.scss","webpack://./src/assets/layout/sass/_menu.scss","webpack://./src/assets/layout/sass/_config.scss","webpack://./src/assets/layout/sass/_content.scss","webpack://./src/assets/layout/sass/_footer.scss","webpack://./src/assets/layout/sass/_responsive.scss","webpack://./src/assets/layout/sass/_utils.scss","webpack://./src/assets/layout/sass/_typography.scss","webpack://./src/assets/layout/_overrides.scss"],"names":[],"mappings":"AAAA,YAAA;ACAA;EACI,sBAAA;ACEJ;;ADCA;EACI,YAAA;ACEJ;;ADCA;EACI,+BAAA;EACA,wBAAA;EACA,uCAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;ACEJ;;ADCA;EACI,qBAAA;EACA,2BAAA;ACEJ;;ADCA;EACI,iBAAA;ACEJ;;AC3BA;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,qCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,6GAAA;AD8BJ;AC5BI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AD8BR;AC5BQ;EACI,cAAA;EACA,oBAAA;AD8BZ;AC3BQ;EC3BJ,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;AFyDJ;AC5BI;EACI,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AD8BR;AC5BQ;EACI,wBAAA;EACA,sCAAA;AD8BZ;AC3BQ;ECjDJ,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;AF+EJ;AC7BQ;EACI,iBAAA;AD+BZ;AC5BQ;EACI,eAAA;EACA,aAAA;AD8BZ;AC1BI;EACI,iBAAA;AD4BR;ACzBI;EACI,aAAA;AD2BR;ACzBQ;EACI,kBAAA;AD2BZ;ACvBI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;ADyBR;ACvBQ;EACI,iBAAA;ADyBZ;;ACpBA;EACI;IACI,8BAAA;EDuBN;ECrBM;IACI,WAAA;IACA,QAAA;EDuBV;ECpBM;IACI,cAAA;IACA,QAAA;EDsBV;ECnBM;IACI,oBAAA;IACA,cAAA;IACA,QAAA;EDqBV;EClBM;IACI,cAAA;IACA,kBAAA;IACA,sBAAA;IACA,wCAAA;IACA,6GAAA;IACA,mBAAA;IACA,aAAA;IACA,WAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IAEA,+BAAA;EDoBV;EClBU;IACI,cAAA;EDoBd;ECjBU;IACI,cAAA;IACA,aAAA;IACA,WAAA;IACA,YAAA;IACA,2BAAA;IACA,mBAAA;IACA,aAAA;EDmBd;ECjBc;IACI,eAAA;IACA,oBAAA;EDmBlB;EChBc;IACI,mBAAA;IACA,cAAA;EDkBlB;AACF;AGlKA;EACI,eAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,qCAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,6GAAA;AHoKJ;;AGjKA;EACI,qBAAA;EACA,SAAA;EACA,UAAA;AHoKJ;AGjKQ;EACI,mBAAA;AHmKZ;AGjKY;EACI,aAAA;AHmKhB;AG/JQ;EACI,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AHiKZ;AG9JQ;EACI,eAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBL3CE;EK4CF,qBAAA;EACA,kCAAA;AHgKZ;AG9JY;EACI,mBAAA;AHgKhB;AG7JY;EACI,iBAAA;AH+JhB;AG5JY;EDjDR,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;AFgNJ;AG9JY;EACI,sCAAA;AHgKhB;AG7JY;EACI,gBAAA;EACA,2BAAA;AH+JhB;AG5JY;EACI,iBAAA;AH8JhB;AGvJoB;EACI,gBAAA;AHyJxB;AGnJQ;EACI,qBAAA;EACA,SAAA;EACA,UAAA;AHqJZ;AGnJY;EACI,aAAA;AHqJhB;AGlJY;EACI,gBAAA;EACA,kBAAA;EACA,qCAAA;AHoJhB;AGjJY;EACI,eAAA;AHmJhB;AGhJY;EACI,kBAAA;AHkJhB;AG/IY;EACI,gBAAA;EACA,aAAA;EACA,2DAAA;AHiJhB;AG9IY;EACI,kBAAA;AHgJhB;;AInQA;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gCAAA;EACA,gCAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,mBAAA;EACA,4CAAA;EACA,+CAAA;EACA,0BAAA;EACA,6BAAA;EACA,uDAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,+CAAA;AJsQJ;AInQI;EACI,eAAA;EACA,0JAAA;EACA,YAAA;AJqQR;AInQM;EACE,eAAA;EACA,iBAAA;EACA,uCAAA;AJqQR;AIlQI;EACI,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AJoQR;AIjQI;EACI,8BAAA;AJmQR;;AI7PQ;EACI,kBAAA;EACA,mBAAA;AJgQZ;;AKlTA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,8BAAA;EACA,4BAAA;EACA,4BAAA;ALqTJ;;AKlTA;EACI,cAAA;ALqTJ;;AM/TA;EACI,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2CAAA;ANkUJ;;AOxUA;EAGY;IACI,cAAA;IACA,kBAAA;EPyUd;EOtUU;IACI,4BAAA;IACA,OAAA;IACA,MAAA;IACA,aAAA;IACA,yBAAA;IACA,4BAAA;EPwUd;EOpUc;IACI,wBAAA;EPsUlB;EOhUU;IACI,kBAAA;EPkUd;EO9Tc;IACI,4BAAA;IACA,OAAA;EPgUlB;EO7Tc;IACI,cAAA;IACA,kBAAA;EP+TlB;EO1TM;IACI,aAAA;EP4TV;AACF;AOxTA;EAEQ;IACI,cAAA;IACA,kBAAA;EPyTV;EOtTM;IACI,4BAAA;IACA,OAAA;IACA,MAAA;IACA,aAAA;IACA,yBAAA;IACA,4BAAA;EPwTV;EOrTM;IACI,YAAA;IACA,gCAAA;EPuTV;EOrTU;IAEI,6BAAA;EPsTd;EOjTU;IACI,wBAAA;EPmTd;EOhTU;IACI,cAAA;EPkTd;EO7SE;IACI,gBAAA;EP+SN;AACF;AQtYA,UAAA;AACA;EACI,YAAA;EACA,cAAA;EACA,WAAA;ARwYJ;;AQrYA;EACI,+BAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBVXU;AEmZd;AQtYI;EACI,gBAAA;ARwYR;;AQnYI;EAGI,UAAA;ARoYR;;AS5ZA;EACI,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AT+ZJ;AS7ZI;EACI,aAAA;AT+ZR;;AS3ZA;EACI,iBAAA;AT8ZJ;;AS3ZA;EACI,eAAA;AT8ZJ;;AS3ZA;EACI,kBAAA;AT8ZJ;;AS3ZA;EACI,iBAAA;AT8ZJ;;AS3ZA;EACI,kBAAA;AT8ZJ;;AS3ZA;EACI,eAAA;AT8ZJ;;AS3ZA;EACI,mBAAA;EACA,uBAAA;EACA,mBXrCU;EWsCV,sBAAA;AT8ZJ;;AS3ZA;EACI,cAAA;EACA,eAAA;EACA,8BAAA;AT8ZJ;;AS3ZA;EACI,uCAAA;EACA,uBAAA;EACA,cAAA;AT8ZJ;;AS3ZA;EACI,kBAAA;EACA,gBAAA;AT8ZJ;AS5ZI;EACI,gBAAA;AT8ZR;;AUxdA;EACI,kCAAA;EACA,wBAAA;AV2dJ;;AUxdA;EACI;IACI,cAAA;IACA,kBAAA;EV2dN;AACF;AUxdA;EACI,eAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,qCAAA;EACA,wCAAA;EACA,kBAAA;EACA,gCAAA;EACA,6GAAA;AV0dJ;;AUvdA;EACI,4BAAA;AV0dJ;;AUtdI;EACI,gBAAA;AVydR;AUvdQ;EACI,aAAA;AVydZ;;AUpdA;EACI,sCAAA;AVudJ;;AUpdA;EACI,kCAAA;AVudJ;;AUndI;EACI,wCAAA;AVsdR;AUndI;EACI,kCAAA;AVqdR;AUndQ;EACI,YAAA;AVqdZ;;AU/cI;EACI,wCAAA;EACA,cAAA;AVkdR;;AU9cA;EACI,wBAAA;AVidJ;;AU9cA;EACI,UAAA;AVidJ;;AU9cA;EACI,cAAA;EACA,UAAA;AVidJ;;AU9cA;EACI,UAAA;AVidJ;;AU9cA;EACI,cAAA;EACA,UAAA;AVidJ;;AU7cI;EACI,mBAAA;AVgdR;;AU5cA;EACI,cAAA;AV+cJ;;AU5cA;EACI,oBAAA;EACA,cAAA;AV+cJ","sourcesContent":["/* General */\n$fontSize:10px;\n$borderRadius:12px;\n$transitionDuration:.2s;\n","* {\n    box-sizing: border-box;\n}\n\nhtml {\n    height: 100%;\n}\n\nbody {\n    font-family: var(--font-family);\n    color: var(--text-color);\n    background-color: var(--surface-ground);\n    margin: 0;\n    padding: 0;\n    min-height: 100%;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\na {\n    text-decoration: none;\n    color: var(--primary-color);\n}\n\n.layout-wrapper {\n    min-height: 100vh;\n}","/* General */\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n}\n\nbody {\n  font-family: var(--font-family);\n  color: var(--text-color);\n  background-color: var(--surface-ground);\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na {\n  text-decoration: none;\n  color: var(--primary-color);\n}\n\n.layout-wrapper {\n  min-height: 100vh;\n}\n\n.layout-topbar {\n  position: fixed;\n  height: 5rem;\n  z-index: 997;\n  left: 0;\n  top: 0;\n  width: 100%;\n  padding: 0 2rem;\n  background-color: var(--surface-card);\n  transition: left 0.2s;\n  display: flex;\n  align-items: center;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);\n}\n.layout-topbar .layout-topbar-logo {\n  display: flex;\n  align-items: center;\n  color: var(--surface-900);\n  font-size: 1.5rem;\n  font-weight: 500;\n  width: 300px;\n  border-radius: 12px;\n}\n.layout-topbar .layout-topbar-logo img {\n  height: 2.5rem;\n  margin-right: 0.5rem;\n}\n.layout-topbar .layout-topbar-logo:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  transition: box-shadow 0.2s;\n  box-shadow: var(--focus-ring);\n}\n.layout-topbar .layout-topbar-button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  color: var(--text-color-secondary);\n  border-radius: 50%;\n  width: 3rem;\n  height: 3rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n.layout-topbar .layout-topbar-button:hover {\n  color: var(--text-color);\n  background-color: var(--surface-hover);\n}\n.layout-topbar .layout-topbar-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  transition: box-shadow 0.2s;\n  box-shadow: var(--focus-ring);\n}\n.layout-topbar .layout-topbar-button i {\n  font-size: 1.5rem;\n}\n.layout-topbar .layout-topbar-button span {\n  font-size: 1rem;\n  display: none;\n}\n.layout-topbar .layout-menu-button {\n  margin-left: 2rem;\n}\n.layout-topbar .layout-topbar-menu-button {\n  display: none;\n}\n.layout-topbar .layout-topbar-menu-button i {\n  font-size: 1.25rem;\n}\n.layout-topbar .layout-topbar-menu {\n  margin: 0 0 0 auto;\n  padding: 0;\n  list-style: none;\n  display: flex;\n}\n.layout-topbar .layout-topbar-menu .layout-topbar-button {\n  margin-left: 1rem;\n}\n\n@media (max-width: 991px) {\n  .layout-topbar {\n    justify-content: space-between;\n  }\n  .layout-topbar .layout-topbar-logo {\n    width: auto;\n    order: 2;\n  }\n  .layout-topbar .layout-menu-button {\n    margin-left: 0;\n    order: 1;\n  }\n  .layout-topbar .layout-topbar-menu-button {\n    display: inline-flex;\n    margin-left: 0;\n    order: 3;\n  }\n  .layout-topbar .layout-topbar-menu {\n    margin-left: 0;\n    position: absolute;\n    flex-direction: column;\n    background-color: var(--surface-overlay);\n    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);\n    border-radius: 12px;\n    padding: 1rem;\n    right: 2rem;\n    top: 5rem;\n    min-width: 15rem;\n    display: none;\n    -webkit-animation: scalein 0.15s linear;\n    animation: scalein 0.15s linear;\n  }\n  .layout-topbar .layout-topbar-menu.layout-topbar-menu-mobile-active {\n    display: block;\n  }\n  .layout-topbar .layout-topbar-menu .layout-topbar-button {\n    margin-left: 0;\n    display: flex;\n    width: 100%;\n    height: auto;\n    justify-content: flex-start;\n    border-radius: 12px;\n    padding: 1rem;\n  }\n  .layout-topbar .layout-topbar-menu .layout-topbar-button i {\n    font-size: 1rem;\n    margin-right: 0.5rem;\n  }\n  .layout-topbar .layout-topbar-menu .layout-topbar-button span {\n    font-weight: medium;\n    display: block;\n  }\n}\n.layout-sidebar {\n  position: fixed;\n  width: 300px;\n  height: calc(100vh - 9rem);\n  z-index: 999;\n  overflow-y: auto;\n  user-select: none;\n  top: 7rem;\n  left: 2rem;\n  transition: transform 0.2s, left 0.2s;\n  background-color: var(--surface-overlay);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);\n}\n\n.layout-menu {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n.layout-menu li.layout-menuitem-category {\n  margin-top: 0.75rem;\n}\n.layout-menu li.layout-menuitem-category:first-child {\n  margin-top: 0;\n}\n.layout-menu li .layout-menuitem-root-text {\n  text-transform: uppercase;\n  color: var(--surface-900);\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  font-size: 0.875rem;\n}\n.layout-menu li a {\n  cursor: pointer;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  color: var(--text-color);\n  transition: color 0.2s;\n  border-radius: 12px;\n  padding: 0.75rem 1rem;\n  transition: background-color 0.15s;\n}\n.layout-menu li a span {\n  margin-left: 0.5rem;\n}\n.layout-menu li a .menuitem-toggle-icon {\n  margin-left: auto;\n}\n.layout-menu li a:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  transition: box-shadow 0.2s;\n  box-shadow: inset var(--focus-ring);\n}\n.layout-menu li a:hover {\n  background-color: var(--surface-hover);\n}\n.layout-menu li a.router-link-exact-active {\n  font-weight: 700;\n  color: var(--primary-color);\n}\n.layout-menu li a .p-badge {\n  margin-left: auto;\n}\n.layout-menu li.active-menuitem > a .menuitem-toggle-icon:before {\n  content: \"\\e933\";\n}\n.layout-menu li ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n.layout-menu li ul.layout-submenu-wrapper-enter {\n  max-height: 0;\n}\n.layout-menu li ul.layout-submenu-wrapper-enter-active {\n  overflow: hidden;\n  max-height: 1000px;\n  transition: max-height 1s ease-in-out;\n}\n.layout-menu li ul.layout-submenu-wrapper-enter-done {\n  transform: none;\n}\n.layout-menu li ul.layout-submenu-wrapper-exit {\n  max-height: 1000px;\n}\n.layout-menu li ul.layout-submenu-wrapper-exit-active {\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height 0.45s cubic-bezier(0.86, 0, 0.07, 1);\n}\n.layout-menu li ul ul {\n  padding-left: 1rem;\n}\n\n.layout-config-button {\n  display: block;\n  position: fixed;\n  width: 3rem;\n  height: 3rem;\n  line-height: 3rem;\n  background: var(--primary-color);\n  color: var(--primary-color-text);\n  text-align: center;\n  top: 50%;\n  right: 0;\n  margin-top: -1.5rem;\n  border-top-left-radius: var(--border-radius);\n  border-bottom-left-radius: var(--border-radius);\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  transition: background-color var(--transition-duration);\n  overflow: hidden;\n  cursor: pointer;\n  z-index: 999;\n  box-shadow: -0.25rem 0 1rem rgba(0, 0, 0, 0.15);\n}\n.layout-config-button.config-link {\n  font-size: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  border: none;\n}\n.layout-config-button .config-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 1px var(--focus-ring);\n}\n.layout-config-button i {\n  font-size: 2rem;\n  line-height: inherit;\n  transform: rotate(0deg);\n  transition: transform 1s;\n}\n.layout-config-button:hover {\n  background: var(--primary-400);\n}\n\n.layout-config-sidebar.p-sidebar .p-sidebar-content {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n.layout-main-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  justify-content: space-between;\n  padding: 7rem 2rem 2rem 4rem;\n  transition: margin-left 0.2s;\n}\n\n.layout-main {\n  flex: 1 1 auto;\n}\n\n.layout-footer {\n  transition: margin-left 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 1rem;\n  border-top: 1px solid var(--surface-border);\n}\n\n@media (min-width: 992px) {\n  .layout-wrapper.layout-overlay .layout-main-container {\n    margin-left: 0;\n    padding-left: 2rem;\n  }\n  .layout-wrapper.layout-overlay .layout-sidebar {\n    transform: translateX(-100%);\n    left: 0;\n    top: 0;\n    height: 100vh;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .layout-wrapper.layout-overlay.layout-overlay-sidebar-active .layout-sidebar {\n    transform: translateX(0);\n  }\n  .layout-wrapper.layout-static .layout-main-container {\n    margin-left: 300px;\n  }\n  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-sidebar {\n    transform: translateX(-100%);\n    left: 0;\n  }\n  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-main-container {\n    margin-left: 0;\n    padding-left: 2rem;\n  }\n  .layout-wrapper .layout-mask {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .layout-wrapper .layout-main-container {\n    margin-left: 0;\n    padding-left: 2rem;\n  }\n  .layout-wrapper .layout-sidebar {\n    transform: translateX(-100%);\n    left: 0;\n    top: 0;\n    height: 100vh;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .layout-wrapper .layout-mask {\n    z-index: 998;\n    background-color: var(--mask-bg);\n  }\n  .layout-wrapper .layout-mask.layout-mask-enter-from, .layout-wrapper .layout-mask.layout-mask-leave-to {\n    background-color: transparent;\n  }\n  .layout-wrapper.layout-mobile-sidebar-active .layout-sidebar {\n    transform: translateX(0);\n  }\n  .layout-wrapper.layout-mobile-sidebar-active .layout-mask {\n    display: block;\n  }\n  .body-overflow-hidden {\n    overflow: hidden;\n  }\n}\n/* Utils */\n.clearfix:after {\n  content: \" \";\n  display: block;\n  clear: both;\n}\n\n.card {\n  background: var(--surface-card);\n  border: 1px solid var(--surface-border);\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: var(--card-shadow);\n  border-radius: 12px;\n}\n.card:last-child {\n  margin-bottom: 0;\n}\n\n.p-toast.p-toast-top-right, .p-toast.p-toast-top-left, .p-toast.p-toast-top-center {\n  top: 100px;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin: 1.5rem 0 1rem 0;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--surface-900);\n}\nh1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child {\n  margin-top: 0;\n}\n\nh1 {\n  font-size: 2.5rem;\n}\n\nh2 {\n  font-size: 2rem;\n}\n\nh3 {\n  font-size: 1.75rem;\n}\n\nh4 {\n  font-size: 1.5rem;\n}\n\nh5 {\n  font-size: 1.25rem;\n}\n\nh6 {\n  font-size: 1rem;\n}\n\nmark {\n  background: #FFF8E1;\n  padding: 0.25rem 0.4rem;\n  border-radius: 12px;\n  font-family: monospace;\n}\n\nblockquote {\n  margin: 1rem 0;\n  padding: 0 2rem;\n  border-left: 4px solid #90A4AE;\n}\n\nhr {\n  border-top: solid var(--surface-border);\n  border-width: 1px 0 0 0;\n  margin: 1rem 0;\n}\n\np {\n  margin: 0 0 1rem 0;\n  line-height: 1.5;\n}\np:last-child {\n  margin-bottom: 0;\n}\n\n.border-left-10 {\n  border-left-width: 10px !important;\n  border-left-style: solid;\n}\n\n@media (min-width: 992px) {\n  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-main-container {\n    margin-left: 0;\n    padding-left: 0rem;\n  }\n}\n.layout-sidebar {\n  position: fixed;\n  width: 300px;\n  height: calc(100vh - 5rem);\n  z-index: 999;\n  overflow-y: auto;\n  user-select: none;\n  top: 5rem;\n  left: 0rem;\n  transition: transform 0.2s, left 0.2s;\n  background-color: var(--surface-overlay);\n  border-radius: 0px;\n  padding: 1.5rem 0rem 0rem 1.5rem;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);\n}\n\n.layout-main-container {\n  padding: 5rem 0rem 0rem 0rem;\n}\n\n.layout-main-card .p-card-body {\n  padding: 0.75rem;\n}\n.layout-main-card .p-card-body .p-card-content {\n  padding: 0rem;\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  padding: 0.5rem 0.75rem 0.5rem 0.75rem;\n}\n\n.p-tabview .p-tabview-panels {\n  padding: 0.5rem 0rem 0.5rem 0.5rem;\n}\n\n.addPanel .p-panel-header {\n  padding: 0.75rem 1.25rem 0.75rem 1.25rem;\n}\n.addPanel .p-panel-content {\n  padding: 0.5rem 0.5rem 0rem 0.5rem;\n}\n.addPanel .p-panel-content .p-inputtext-sm {\n  height: 40px;\n}\n\n.editMode .p-panel-header {\n  padding: 0.75rem 1.25rem 0.75rem 1.25rem;\n  color: #EF4444;\n}\n\n.rotate-45 {\n  transform: rotate(45deg);\n}\n\n.rowDelete {\n  opacity: 0;\n}\n\n.p-datatable-tbody > tr:not(.p-datatable-emptymessage):hover .rowDelete {\n  color: #EF4444;\n  opacity: 1;\n}\n\n.rowEdit {\n  opacity: 0;\n}\n\n.p-datatable-tbody > tr:not(.p-datatable-emptymessage):hover .rowEdit {\n  color: #3B82F6;\n  opacity: 1;\n}\n\n.isCheckbox .p-checkbox-box {\n  margin-top: 0.75rem;\n}\n\n.trashIcon {\n  color: #EF4444;\n}\n\n.p-column-filter-menu {\n  display: inline-flex;\n  margin-left: 0;\n}",".layout-topbar {\n    position: fixed;\n    height: 5rem;\n    z-index: 997;\n    left: 0;\n    top: 0;\n    width: 100%;\n    padding: 0 2rem;\n    background-color: var(--surface-card);\n    transition: left $transitionDuration;\n    display: flex;\n    align-items: center;\n    box-shadow: 0px 3px 5px rgba(0,0,0,.02), 0px 0px 2px rgba(0,0,0,.05), 0px 1px 4px rgba(0,0,0,.08);\n\n    .layout-topbar-logo {\n        display: flex;\n        align-items: center;\n        color: var(--surface-900);\n        font-size: 1.5rem;\n        font-weight: 500;\n        width: 300px;\n        border-radius: 12px;\n\n        img {\n            height: 2.5rem;\n            margin-right: .5rem;\n        }\n\n        &:focus {\n            @include focused();\n        }\n    }\n\n    .layout-topbar-button {\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        color: var(--text-color-secondary);\n        border-radius: 50%;\n        width: 3rem;\n        height: 3rem;\n        cursor: pointer;\n        transition: background-color $transitionDuration;\n\n        &:hover {\n            color: var(--text-color);\n            background-color: var(--surface-hover);\n        }\n\n        &:focus {\n            @include focused();\n        }\n\n        i {\n            font-size: 1.5rem;\n        }\n\n        span {\n            font-size: 1rem;\n            display: none;\n        }\n    }\n\n    .layout-menu-button {\n        margin-left: 2rem;\n    }\n\n    .layout-topbar-menu-button {\n        display: none;\n\n        i {\n            font-size: 1.25rem;\n        }\n    }\n\n    .layout-topbar-menu {\n        margin: 0 0 0 auto;\n        padding: 0;\n        list-style: none;\n        display: flex;\n\n        .layout-topbar-button {\n            margin-left: 1rem;\n        }\n    }\n}\n\n@media (max-width: 991px) {\n    .layout-topbar {\n        justify-content: space-between;\n\n        .layout-topbar-logo {\n            width: auto;\n            order: 2;\n        }\n\n        .layout-menu-button {\n            margin-left: 0;\n            order: 1;\n        }\n\n        .layout-topbar-menu-button {\n            display: inline-flex;\n            margin-left: 0;\n            order: 3;\n        }\n\n        .layout-topbar-menu {\n            margin-left: 0;\n            position: absolute;\n            flex-direction: column;\n            background-color: var(--surface-overlay);\n            box-shadow: 0px 3px 5px rgba(0,0,0,.02), 0px 0px 2px rgba(0,0,0,.05), 0px 1px 4px rgba(0,0,0,.08);\n            border-radius: 12px;\n            padding: 1rem;\n            right: 2rem;\n            top: 5rem;\n            min-width: 15rem;\n            display: none;\n            -webkit-animation: scalein 0.15s linear;\n            animation: scalein 0.15s linear;\n\n            &.layout-topbar-menu-mobile-active {\n                display: block\n            }\n\n            .layout-topbar-button {\n                margin-left: 0;\n                display: flex;\n                width: 100%;\n                height: auto;\n                justify-content: flex-start;\n                border-radius: 12px;\n                padding: 1rem;\n\n                i {\n                    font-size: 1rem;\n                    margin-right: .5rem;\n                }\n\n                span {\n                    font-weight: medium;\n                    display: block;\n                }\n            }\n        }\n    }\n}\n","@mixin focused() {\n    outline: 0 none;\n    outline-offset: 0;\n    transition: box-shadow .2s;\n    box-shadow: var(--focus-ring);\n}\n\n@mixin focused-inset() {\n    outline: 0 none;\n    outline-offset: 0;\n    transition: box-shadow .2s;\n    box-shadow: inset var(--focus-ring);\n}\n",".layout-sidebar {\n    position: fixed;\n    width: 300px;\n    height: calc(100vh - 9rem);\n    z-index: 999;\n    overflow-y: auto;\n    user-select: none;\n    top: 7rem;\n    left: 2rem;\n    transition: transform $transitionDuration, left $transitionDuration;\n    background-color: var(--surface-overlay);\n    border-radius: 12px;\n    padding: 1.5rem;\n    box-shadow: 0px 3px 5px rgba(0,0,0,.02), 0px 0px 2px rgba(0,0,0,.05), 0px 1px 4px rgba(0,0,0,.08)\n}\n\n.layout-menu {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n\n    li {\n        &.layout-menuitem-category {\n            margin-top: .75rem;\n\n            &:first-child {\n                margin-top: 0;\n            }\n        }\n\n        .layout-menuitem-root-text {\n            text-transform: uppercase;\n            color:var(--surface-900);\n            font-weight: 600;\n            margin-bottom: .5rem;\n            font-size: .875rem;\n        }\n\n        a {\n            cursor: pointer;\n            text-decoration: none;\n            display: flex;\n            align-items: center;\n            color:var(--text-color);\n            transition: color $transitionDuration;\n            border-radius: $borderRadius;\n            padding: .75rem 1rem;\n            transition: background-color .15s;\n\n            span {\n                margin-left: 0.5rem;\n            }\n\n            .menuitem-toggle-icon {\n                margin-left: auto;\n            }\n\n            &:focus {\n                @include focused-inset();\n            }\n\n            &:hover {\n                background-color: var(--surface-hover);\n            }\n\n            &.router-link-exact-active {\n                font-weight: 700;\n                color: var(--primary-color);\n            }\n\n            .p-badge {\n                margin-left: auto;\n            }\n        }\n\n        &.active-menuitem {\n            > a {\n                .menuitem-toggle-icon {\n                    &:before {\n                        content: '\\e933';\n                    }\n                }\n            }\n        }\n\n        ul {\n            list-style-type: none;\n            margin: 0;\n            padding: 0;\n\n            &.layout-submenu-wrapper-enter {\n                max-height: 0;\n            }\n\n            &.layout-submenu-wrapper-enter-active {\n                overflow: hidden;\n                max-height: 1000px;\n                transition: max-height 1s ease-in-out;\n            }\n\n            &.layout-submenu-wrapper-enter-done {\n                transform: none;\n            }\n\n            &.layout-submenu-wrapper-exit {\n                max-height: 1000px;\n            }\n\n            &.layout-submenu-wrapper-exit-active {\n                overflow: hidden;\n                max-height: 0;\n                transition: max-height 0.45s cubic-bezier(0.86, 0, 0.07, 1);\n            }\n\n            ul {\n                padding-left: 1rem;\n            }\n        }\n    }\n}\n",".layout-config-button {\n    display: block;\n    position: fixed;\n    width: 3rem;\n    height: 3rem;\n    line-height: 3rem;\n    background: var(--primary-color);\n    color: var(--primary-color-text);\n    text-align: center;\n    top: 50%;\n    right: 0;\n    margin-top: -1.5rem;\n    border-top-left-radius: var(--border-radius);\n    border-bottom-left-radius: var(--border-radius);\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    transition: background-color var(--transition-duration);\n    overflow: hidden;\n    cursor: pointer;\n    z-index: 999;\n    box-shadow: -.25rem 0 1rem rgba(0,0,0,.15);\n\n\n    &.config-link {\n        font-size: 1rem;\n        font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n        border: none;\n      }\n      .config-link:focus {\n        outline: 0 none;\n        outline-offset: 0;\n        box-shadow: 0 0 0 1px var(--focus-ring);\n      }\n\n    i {\n        font-size: 2rem;\n        line-height: inherit;\n        transform: rotate(0deg);\n        transition: transform 1s;\n    }\n\n    &:hover {\n        background: var(--primary-400);\n    }\n}\n\n.layout-config-sidebar {\n    &.p-sidebar {\n        .p-sidebar-content {\n            padding-left: 2rem;\n            padding-right: 2rem;\n        }\n    }\n} ",".layout-main-container {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    justify-content: space-between;\n    padding: 7rem 2rem 2rem 4rem;\n    transition: margin-left $transitionDuration;\n}\n\n.layout-main {\n    flex: 1 1 auto;\n}\n",".layout-footer {\n    transition: margin-left $transitionDuration;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 1rem;\n    border-top: 1px solid var(--surface-border);\n}\n","@media (min-width: 992px) {\n    .layout-wrapper {\n        &.layout-overlay {\n            .layout-main-container {\n                margin-left: 0;\n                padding-left: 2rem;\n            }\n\n            .layout-sidebar {\n                transform: translateX(-100%);\n                left: 0;\n                top: 0;\n                height: 100vh;\n                border-top-left-radius: 0;\n                border-bottom-left-radius: 0;\n            }\n\n            &.layout-overlay-sidebar-active {\n                .layout-sidebar {\n                    transform: translateX(0);\n                }\n            }\n        }\n\n        &.layout-static {\n            .layout-main-container {\n                margin-left: 300px;\n            }\n\n            &.layout-static-sidebar-inactive {\n                .layout-sidebar {\n                    transform: translateX(-100%);\n                    left: 0;\n                }\n\n                .layout-main-container {\n                    margin-left: 0;\n                    padding-left: 2rem;\n                }\n            }\n        }\n\n        .layout-mask {\n            display: none;\n        }\n    }\n}\n\n@media (max-width: 991px) {\n    .layout-wrapper {\n        .layout-main-container {\n            margin-left: 0;\n            padding-left: 2rem;\n        }\n\n        .layout-sidebar {\n            transform: translateX(-100%);\n            left: 0;\n            top: 0;\n            height: 100vh;\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n\n        .layout-mask {\n            z-index: 998;\n            background-color: var(--mask-bg);\n\n            &.layout-mask-enter-from,\n            &.layout-mask-leave-to {\n                background-color: transparent;\n            }\n        }\n\n        &.layout-mobile-sidebar-active {\n            .layout-sidebar {\n                transform: translateX(0);\n            }\n\n            .layout-mask {\n                display: block;\n            }\n        }\n    }\n\n    .body-overflow-hidden {\n        overflow: hidden;\n    }\n}\n","/* Utils */\n.clearfix:after {\n    content: \" \";\n    display: block;\n    clear: both;\n}\n\n.card {\n    background: var(--surface-card);\n    border: 1px solid var(--surface-border);\n    padding: 2rem;\n    margin-bottom: 2rem;\n    box-shadow: var(--card-shadow);\n    border-radius: $borderRadius;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n\n.p-toast {\n    &.p-toast-top-right,\n    &.p-toast-top-left,\n    &.p-toast-top-center {\n        top: 100px;\n    }\n}","h1, h2, h3, h4, h5, h6 {\n    margin: 1.5rem 0 1rem 0;\n    font-family: inherit;\n    font-weight: 500;\n    line-height: 1.2;\n    color: var(--surface-900);\n\n    &:first-child {\n        margin-top: 0;\n    }\n}\n\nh1 {\n    font-size: 2.5rem;\n}\n\nh2 {\n    font-size: 2rem;\n}\n\nh3 {\n    font-size: 1.75rem;\n}\n\nh4 {\n    font-size: 1.5rem;\n}\n\nh5 {\n    font-size: 1.25rem;\n}\n\nh6 {\n    font-size: 1rem;\n}\n\nmark {\n    background: #FFF8E1;\n    padding: .25rem .4rem;\n    border-radius: $borderRadius;\n    font-family: monospace;\n}\n\nblockquote {\n    margin: 1rem 0;\n    padding: 0 2rem;\n    border-left: 4px solid #90A4AE;\n}\n\nhr {\n    border-top: solid var(--surface-border);\n    border-width: 1px 0 0 0;\n    margin: 1rem 0;\n}\n\np {\n    margin: 0 0 1rem 0;\n    line-height: 1.5;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n","//Suggested location to add your overrides so that migration would be easy by just updating the SASS folder in the future\n\n.border-left-10 {\n    border-left-width: 10px !important;\n    border-left-style: solid;\n}\n\n@media (min-width: 992px) {\n    .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-main-container {\n        margin-left: 0;\n        padding-left: 0rem;\n    }\n}\n\n.layout-sidebar {\n    position: fixed;\n    width: 300px;\n    height: calc(100vh - 5rem);\n    z-index: 999;\n    overflow-y: auto;\n    user-select: none;\n    top: 5rem;\n    left: 0rem;\n    transition: transform $transitionDuration, left $transitionDuration;\n    background-color: var(--surface-overlay);\n    border-radius: 0px;\n    padding: 1.5rem 0rem 0rem 1.5rem;\n    box-shadow: 0px 3px 5px rgba(0, 0, 0, .02), 0px 0px 2px rgba(0, 0, 0, .05), 0px 1px 4px rgba(0, 0, 0, .08)\n}\n\n.layout-main-container {\n    padding: 5rem 0rem 0rem 0rem;\n}\n\n.layout-main-card {\n    .p-card-body {\n        padding: 0.75rem;\n\n        .p-card-content {\n            padding: 0rem;\n        }\n    }\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n    padding: 0.5rem 0.75rem 0.5rem 0.75rem;\n}\n\n.p-tabview .p-tabview-panels {\n    padding: 0.5rem 0rem 0.5rem 0.5rem;\n}\n\n.addPanel {\n    .p-panel-header {\n        padding: 0.75rem 1.25rem 0.75rem 1.25rem;\n    }\n\n    .p-panel-content {\n        padding: 0.5rem 0.5rem 0rem 0.5rem;\n\n        .p-inputtext-sm {\n            height: 40px;\n        }\n    }\n}\n\n.editMode {\n    .p-panel-header {\n        padding: 0.75rem 1.25rem 0.75rem 1.25rem;\n        color:#EF4444;\n    }\n}\n\n.rotate-45 {\n    transform: rotate(45deg);\n}\n\n.rowDelete {\n    opacity: 0;\n}\n\n.p-datatable-tbody>tr:not(.p-datatable-emptymessage):hover .rowDelete {\n    color: #EF4444;\n    opacity: 1;\n}\n\n.rowEdit {\n    opacity: 0;\n}\n\n.p-datatable-tbody>tr:not(.p-datatable-emptymessage):hover .rowEdit {\n    color: #3B82F6;\n    opacity: 1;\n}\n\n.isCheckbox {\n    .p-checkbox-box {\n        margin-top: 0.75rem;\n    }\n}\n\n.trashIcon {\n    color: #EF4444;\n}\n\n.p-column-filter-menu {\n    display: inline-flex;\n    margin-left: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
